/**
 * Better Auth client for WaifuDo frontend.
 * Replaces Supabase Auth.
 */
import { createAuthClient } from 'better-auth/react'
import { magicLinkClient } from 'better-auth/client/plugins'

const API_URL = import.meta.env.VITE_API_URL || ''

export const authClient = createAuthClient({
  baseURL: API_URL,
  plugins: [magicLinkClient()],
})

export const {
  signIn,
  signUp,
  signOut,
  useSession,
  getSession,
} = authClient
